import React, { useEffect } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { useKeycloak } from './KeycloakContext';
import { useSession } from './SessionContext';

function ProtectedRoute({ children }) {
    const {
        initialized,
        authenticated,
        login,
    } = useKeycloak();

    const {
        session,
        sessionLoaded,
        sessionError,
    } = useSession();

    useEffect(() => {
        if (initialized && !authenticated) {
            login();
        }
    }, [initialized, authenticated, login]);

    if (!initialized || !authenticated || !sessionLoaded) {
        return (
            <div className="loading-container">
                <TailSpin
                    height="80"
                    width="80"
                    color="#0c1534"
                    ariaLabel="A carregar sessão"
                />
            </div>
        );
    }

    if (sessionError || !session) {
        return (
            <div className="access-denied-container">
                <div className="login-box">
                    <h2>Acesso negado</h2>

                    <p>
                        Não foi possível carregar o seu acesso ao Carsharing.
                    </p>
                </div>
            </div>
        );
    }

    return children;
}

export default ProtectedRoute;